import moment from "moment/moment";
import React, { useEffect, useState } from "react";
import Barcode from "react-barcode";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useSelector } from "react-redux";
import { succsesDataChangeAlert } from "../../../alerts/alerts";
import { useGetPageQuery, useSendFormMutation } from "../../../redux/services/crmAPI";
import { PaginatedItems } from "../../pagination/Pagination";

const TransferLogModal = ({ showModal, setShowModal }) => {
    const handleClose = () => setShowModal(false);
    const basicBarCode = "00000000";

    const [logsList, setLogsList] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [selectStatus, setSelectStatus] = useState("accept");
    const [isActive, setIsActive] = useState(1);

    const pagination = "&page=" + currentPage;
    const isActivParams = "&is_active=" + isActive;

    const { data: transfers, refetch: refetchTransfers } = useGetPageQuery(
        "transfers?per_page=10" + pagination + isActivParams
    );
    const [sendForm, { isLoading, isSuccess }] = useSendFormMutation();
    const userId = useSelector((state) => state?.status?.userPermission?.id ?? 0);

    useEffect(() => {
        const refetch = async () => {
            refetchTransfers();
        };
        refetch();
    }, [showModal, isActive]);

    const listCheckHandler = (e) => {
        if (e.target.checked) {
            setLogsList([...logsList, e.target.value]);
        } else if (!e.target.checked) {
            setLogsList([...logsList.filter((id) => id !== e.target.value)]);
        }
    };

    const setStatusHandler = (state) => {
        if (state === "moving") {
            return "Товар відправлений";
        } else if (state === "sent") {
            return "Товар прийнятий";
        } else if (state === "reject") {
            return "Переміщення відмінено";
        }
        // if (senderId === userId) {
        //     if (senderId === resiverId && isSuccess) {
        //         return "Товар прийнятий";
        //     } else if (senderId === resiverId) {
        //         return "Переміщення відмінено";
        //     } else if (resiverId === 0) {
        //         return "Товар відправлений";
        //     } else if (resiverId) {
        //         return "Товар прийнятий";
        //     }
        // } else {
        //     if (resiverId === 0) {
        //         return "Товар очікує прийняття";
        //     } else if (resiverId) {
        //         return "Товар прийнятий";
        //     } else if (senderId === resiverId) {
        //         return "Переміщення відмінено";
        //     }
        // }
    };

    useEffect(() => {
        if (isSuccess) {
            succsesDataChangeAlert();
        }
    }, [isLoading]);

    const sendFormHandler = async () => {
        const productIds = transfers.data
            .map((transfer) => (logsList.includes(transfer.id.toString()) ? transfer.product_id : undefined))
            .filter((transfer) => transfer);

        const formData = {
            product_ids: productIds,
        };

        await sendForm({ body: formData, url: `transfers/${selectStatus}?move=1`, method: "POST" }).unwrap();

        await refetchTransfers();
    };

    console.log(transfers);

    return (
        <Modal
            show={showModal}
            onHide={handleClose}
            size="xl"
            centered
        >
            <Modal.Header closeButton>
                <Modal.Title>Переміщення товарів</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <ul className="nav-bordered nav nav-tabs mb-3">
                    <li className="nav-item">
                        <div
                            className={isActive ? "nav-link active" : "nav-link"}
                            onClick={() => setIsActive(1)}
                        >
                            <span className=" d-lg-block">Активні</span>
                        </div>
                    </li>
                    <li className="nav-item">
                        <div
                            className={!isActive ? "nav-link active" : "nav-link"}
                            onClick={() => setIsActive(0)}
                        >
                            <span className=" d-lg-block">Деактивовані</span>
                        </div>
                    </li>
                </ul>
                {transfers && (
                    <>
                        <table className={"table table-striped"}>
                            <thead>
                                <tr>
                                    <th data-field="check"></th>
                                    <th
                                        data-field="id"
                                        className=" align-middle "
                                    >
                                        ID
                                    </th>
                                    <th
                                        data-field="user_name"
                                        className="align-middle"
                                    >
                                        Назва
                                    </th>
                                    <th
                                        data-field="user_status"
                                        className="no-mobile align-middle no-mobile-modal"
                                    >
                                        Відправник
                                    </th>
                                    <th
                                        data-field="user_status"
                                        className="no-mobile align-middle no-mobile-modal"
                                    >
                                        Відправлено з магазину:
                                    </th>
                                    <th
                                        data-field="user_status"
                                        className="no-mobile align-middle no-mobile-modal"
                                    >
                                        Відправлено у магазин:
                                    </th>
                                    <th
                                        data-field="user_status"
                                        className="no-mobile align-middle"
                                    >
                                        Дата відправки
                                    </th>
                                    <th
                                        data-field="user_status"
                                        className="no-mobile align-middle"
                                    >
                                        Кількість
                                    </th>
                                    <th
                                        data-field="user_telegram"
                                        className="no-mobile align-middle"
                                    >
                                        Статус
                                    </th>
                                    <th
                                        data-field="user_telegram"
                                        className="no-mobile align-middle"
                                    >
                                        Причина
                                    </th>
                                    <th
                                        data-field="user_status"
                                        className="no-mobile align-middle no-mobile-modal-small"
                                    >
                                        Баркод
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {transfers?.data.map((transfer) => {
                                    return (
                                        <tr key={transfer.id}>
                                            <td className="check_area text-right">
                                                <div className="custom-control custom-checkbox">
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        checked={logsList.includes(transfer?.id.toString())}
                                                        value={transfer.id}
                                                        onChange={(e) => listCheckHandler(e)}
                                                    />
                                                    <label className="custom-control-label">&nbsp;</label>
                                                </div>
                                            </td>
                                            <td className="no-mobile">{transfer?.id ?? 0}</td>
                                            <td className="">
                                                {transfer?.title}
                                                {transfer?.imei_sn ? `(${transfer?.imei_sn.slice(-5)})` : ""}
                                            </td>
                                            <td className="no-mobile no-mobile-modal">{transfer?.sender?.name}</td>
                                            <td className="no-mobile no-mobile-modal">{transfer?.from?.title}</td>
                                            <td className="no-mobile no-mobile-modal">{transfer?.to?.title}</td>
                                            <td className="no-mobile">
                                                {moment(transfer.created_at).format("DD.MM.YYYY HH:MM")}
                                            </td>

                                            <td className="no-mobile">{transfer?.count}</td>
                                            <td className="">{setStatusHandler(transfer?.state)}</td>
                                            <td className="no-mobile">{transfer?.reason ? transfer?.reason : "-"}</td>
                                            <td className="no-mobile no-mobile-modal-small">
                                                <Barcode
                                                    width={1.5}
                                                    margin={1}
                                                    height={25}
                                                    displayValue={false}
                                                    value={
                                                        basicBarCode.slice(transfer.product_id.length) +
                                                        transfer.product_id
                                                    }
                                                />
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        </table>
                        <nav>
                            <PaginatedItems
                                pageCount={transfers.last_page}
                                setCurrentPage={setCurrentPage}
                            />
                        </nav>
                    </>
                )}
            </Modal.Body>

            <Modal.Footer>
                <select
                    name="action"
                    className="form-select"
                    style={{ width: "auto" }}
                    value={selectStatus}
                    onChange={(e) => setSelectStatus(e.target.value)}
                >
                    <option value="accept">Прийняти</option>
                    <option value="decline">Відхилити</option>
                </select>
                <Button
                    variant="primary"
                    onClick={sendFormHandler}
                >
                    {false ? "Завантаження" : "Змінити"}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default TransferLogModal;
